import axios from '../axios';
import util from './util';
const apiPath = 'api/admin/investments';

const investmentApi = {
    index: query => {
        return axios.get(
            `${
                process.env.VUE_APP_API_ENDPOINT
            }/${apiPath}/index?${util.queryToString(query)}`
        );
    }
};

export default investmentApi;
